var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVenDiagram = function SvgVenDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 43.5,
    r: 23.5,
    fill: "#FF9D43"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 26.5,
    r: 23.5,
    fill: "#2F68D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M20.717 20.717A23.6 23.6 0 0 1 26.5 20C39.479 20 50 30.521 50 43.5c0 1.996-.249 3.933-.717 5.783-1.85.468-3.787.717-5.783.717C30.521 50 20 39.479 20 26.5c0-1.996.249-3.933.717-5.783",
    clipRule: "evenodd"
  })));
};
export default SvgVenDiagram;